module.exports = __webpack_public_path__ + "static/img/dishini.41b9c768.png";